import { InboxOutlined } from '@ant-design/icons';
import { Button, message } from 'antd';
import Dragger from 'antd/lib/upload/Dragger';

import { uploadMandateApproveBulk } from 'api/nach';
import Loading from 'features/nach/components/Loading';

import { useCallback, useState } from 'react';
import { CSVLink } from 'react-csv';

// Define expected headers as keys from the CSV template in the desired format
const expectedHeaders = [
  { label: 'LAN Number', key: 'lanNumber' },
  { label: 'CIF', key: 'cif' },
  { label: 'Maximum Billing Amount', key: 'maximumBillingAmount' },
  { label: 'Mandate Amount', key: 'mandateAmount' },
  { label: 'Name', key: 'name' },
  { label: 'Contact Number', key: 'contactNumber' },
  { label: 'Email ID', key: 'emailId' },
  { label: 'Relationship With Applicant', key: 'relationshipWithApplicant' },
  { label: 'NACH Type', key: 'nachType' },
  { label: 'IsEditable(YES/NO)', key: 'isEditable' },
  { label: 'Account Number', key: 'accountNumber' },
  { label: 'IFSC Code', key: 'ifscCode' },
  { label: 'Account Name', key: 'accountName' },
  { label: 'Account Type', key: 'accountType' },
];

export default function Index() {
  const [isLoading, setIsLoading] = useState(false);
  const fileResponse = '+rzLV96cC8h+tcr6mJ3VE/NHKx4M8smdL5wy3nylXIvurXpbXUOtsod4wNpevKtZ';
  const handleUpload = useCallback(async (file: any) => {
    const fileType = file.type;
    const validTypes = ['text/csv', 'text/plain']; // Added support for .txt

    if (!validTypes.includes(fileType)) {
      message.error('Invalid file type. Please upload a CSV or text file.');
      return;
    }
    const reader = new FileReader();

    reader.onload = async () => {
      const content = reader.result as string;

      // Split content by new lines to get rows
      const rows = content.trim().split(/\r?\n/);

      // Check header row
      const headerRow = rows[0] ? rows[0].split(/\t|,/).map((header) => header.trim()) : []; // Split by both comma and tab
      const dataRows = rows.slice(1);
      if (dataRows.length === 0) {
        message.error('File has no data, Please fill the file and reupload');
        return;
      }

      // Normalize headers: Convert headers to lowercase and trim any spaces
      const normalizedHeaderRow = headerRow.map((header) => header.toLowerCase());
      // console.log('normalizedHeaderRow: ', normalizedHeaderRow);

      // Normalize expected headers to lowercase and trim spaces
      const normalizedExpectedHeaders = expectedHeaders.map((header) => header.label.toLowerCase());
      // console.log('normalizedExpectedHeaders: ', normalizedExpectedHeaders);

      // Validate header row with expected headers
      const isHeaderValid =
        normalizedHeaderRow.length === normalizedExpectedHeaders.length &&
        normalizedHeaderRow.every((header, index) => header === normalizedExpectedHeaders[index]);

      if (!isHeaderValid) {
        message.error(
          'File header is incorrect. Please make sure the file has the same headers as the downloaded template.'
        );
        return;
      }

      // Data row validation
      if (dataRows.length < 10) {
        message.error('File should have more than 10 row');
        return;
      }
      if (dataRows.length > 5000) {
        message.error('File should have less than 5000 rows');
        return;
      }

      // Detect delimiter (comma or tab)
      const combinedRows = [headerRow, ...dataRows];
      const delimiter = combinedRows.some((row) => row.includes('\t')) ? '\t' : ',';

      // Process each data row and convert tab-separated values to comma-separated
      const processedDataRows = dataRows.map((row) => {
        const trimmedRow = row.trim();
        return trimmedRow.split(delimiter).join(',');
      });

      const blob = new Blob([headerRow.join(',') + '\n' + processedDataRows.join('\n')], {
        type: 'text/csv',
      });

      const formdata = new FormData();
      const sourceId = sessionStorage.getItem('sourceId') || '';
      const createBy = sessionStorage.getItem('userId') || '';
      // console.log('created by', createBy);

      formdata.append('presentmentFile', blob, 'processed_data.csv');
      formdata.append('sourceId', sourceId);
      formdata.append('createBy', createBy);
      formdata.append('fileName', file.name);

      setIsLoading(true);
      try {
        const response = await fetch(uploadMandateApproveBulk, {
          method: 'POST',
          body: formdata,
        });
        debugger;
        if (response.ok) {
          message.success('File is processing please wait for sometime.');
        } else {
          const errorData = await response.text();
          if (errorData == fileResponse) {
            message.error('Duplicate File found');
            return;
          }
          message.error('Failed To upload data');
        }
      } catch (error) {
        console.error('Error uploading file:', error);
        message.error('Failed to upload data!');
      } finally {
        setIsLoading(false); // Always stop loading
      }
    };

    reader.readAsText(file);
  }, []);
  const fileName = `NACH Bulk Upload - ${new Date().toLocaleDateString()}`;

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Loading isLoading={isLoading} />
      <div style={{ margin: '14px', maxWidth: '480px', maxHeight: '480px', padding: '20px' }}>
        <Dragger beforeUpload={handleUpload} showUploadList={false}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">Click or drag file to this area to upload</p>
          <p className="ant-upload-hint">
            Support for a single CSV upload. Strictly prohibited from uploading other files.
          </p>
        </Dragger>
        <CSVLink
          data={[]}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '30px',
          }}
          headers={expectedHeaders}
          filename={fileName}
        >
          <Button type="primary">Download Template</Button>
        </CSVLink>
      </div>
    </div>
  );
}
